import { i18n } from "translate/i18n";

export const weHadToChangeTheVersion = i18n.t(
  "messages.weHadToChangeTheVersion"
);
